import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-indigo-500 text-white",
        secondary: "bg-slate-100 text-slate-600",
        destructive: "bg-red-500 text-white",
        outline: "text-slate-700 border border-slate-200",
        // Customer Status - Fresh design
        hot: "bg-emerald-50 text-emerald-700 border border-emerald-100",
        warm: "bg-amber-50 text-amber-700 border border-amber-100",
        cold: "bg-slate-100 text-slate-600 border border-slate-200",
        // Pipeline Stages - Updated with indigo for contacted
        "stage-new": "bg-slate-100 text-slate-600",
        "stage-contacted": "bg-indigo-50 text-indigo-700",
        "stage-test-drive": "bg-violet-50 text-violet-700",
        "stage-negotiation": "bg-amber-50 text-amber-700",
        "stage-won": "bg-emerald-50 text-emerald-700",
        "stage-lost": "bg-red-50 text-red-700",
        // Task Priorities - Rounded lg for better look
        "priority-urgent": "bg-red-50 text-red-700 rounded-lg",
        "priority-normal": "bg-indigo-50 text-indigo-700 rounded-lg",
        "priority-low": "bg-slate-100 text-slate-500 rounded-lg",
        // Vehicle Status - Fresh design with indigo for available
        available: "bg-indigo-500 text-white",
        sold: "bg-slate-800 text-white",
        reserved: "bg-violet-50 text-violet-700",
        pending: "bg-amber-50 text-amber-700",
        // Lead Sources
        "source-walk-in": "bg-indigo-50 text-indigo-600",
        "source-phone": "bg-emerald-50 text-emerald-600",
        "source-website": "bg-violet-50 text-violet-600",
        "source-social": "bg-rose-50 text-rose-600",
        "source-referral": "bg-amber-50 text-amber-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
